module.exports = __webpack_public_path__ + "img/badge_gray_adv-supports.5d8a4341.svg";